<template>
  <div class="brandDynamic">
    <div class="dp_2_2" id="dp_2_2">
      <div
        v-for="(item,index) in brandDynamics"
        :key="item.id"
        @mouseover="mouseOver(index)" 
        :style="{background: index == currentIndex?styleHover.background:'',
                boxShadow: index == currentIndex?styleHover.boxShadow:''}"
      >
      <router-link
        :to="'/newdetail/' + item.id"
        class="dp_2_21">
        <img :src="item.image" />
        <div>
          <p class="dp_2_21id1">{{ item.title }}</p>
          <p class="dp_2_21id2">
            {{ item.description }}
          </p>
          <p class="dp_2_21id3">{{ item.createTime }}</p>
        </div>
      </router-link>
      </div>
    </div>
    <div class="bd1" id="bd1">
      <p>{{ $t("noData") }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "brandDynamic",
  props: {
    brandDynamics: Array,
  },
  created(){
    this.mouseOver(0);
  },
  mounted(){
    
  },
  updated(){
    if(this.brandDynamics.length == 0){
      document.getElementById("bd1").style.display = "block";
    }else{
      document.getElementById("bd1").style.display = "none";
    }
  },
  methods: {
    mouseOver(index){
      this.currentIndex = index;
    }
  },
  data() {
    return {
      currentIndex: 0,
      styleHover: {
        background: '#fffffe',
        boxShadow: '0px 0px 24px 0px rgba(84, 92, 96, 0.12)'
      },
    };
  },
};
</script>

<style>
.brandDynamic {
  width: 100%;
  text-align: left;
}
.bd1 {
  text-align: center;
  display: flex;
  justify-content: center;
  line-height: 200px;
  width: 1200px;
  height: 200px;
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #696969;
  display: none;
}
.dp_2_1 p {
  font-size: 32px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #181818;
}
.dp_2_1 div {
  width: 120px;
  height: 6px;
  margin-top: 10px;
  background-color: rgba(10, 177, 255, 1);
}
.dp_2_2 {
  width: 100%;
}
.dp_2_21 {
  width: 100%;
  height: 300px;
  margin-top: 40px;
  background-color: white;
  border-radius: 5px;
  display: flex;
  align-items: center;
  text-decoration: none;
}
.dp_2_21:hover {
  /* background: #fffffe;
  box-shadow: 0px 0px 24px 0px rgba(84, 92, 96, 0.12); */
}
.dp_2_21 img {
  margin-left: 60px;
  width: 256px;
  height: 174px;
}
.dp_2_21 div {
  width: 768px;
  height: 174px;
  margin-left: 60px;
}
.dp_2_21id1 {
  font-size: 24px;
  width: 600px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #292929;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dp_2_21id2 {
  margin-top: 20px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #696969;
  width: 600px;
  height: 60px;
  line-height: 32px;
}
.dp_2_21id3 {
  margin-top: 30px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  line-height: 26px;
}
</style>



// WEBPACK FOOTER //
// src/components/component/brandDynamic.vue